import React, { useEffect, useState } from 'react';
import { get_all_agences, get_all_users } from '../../api/users';

const Task = () => {
    const [listAgence, setListeAgence] = useState([])
    const [listeUsers, setlisteUsers] = useState([]);

    useEffect(() => {
        fetchListeAgence()
        fetchUsers()
    }, []);

    const fetchListeAgence = async () => {
        const res = await get_all_agences();
        if (res.status === "success") {
            setListeAgence(res.data);
        }
    };

    const fetchUsers = async () => {
        const res = await get_all_users();
        setlisteUsers(res.data);
    };


    return (
        <div>

        </div>
    );
}

export default Task;
